"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Tooltip = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Tooltip"));
var _SidebarItem = _interopRequireDefault(require("@mulesoft/exchange-ui-components/lib/components/SidebarItem"));
var InfoSmallIcon = function InfoSmallIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16zM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12zm7-2a1 1 0 0 1 1-1h1a2 2 0 0 1 2 2v4h1a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2h1v-4h-1a1 1 0 0 1-1-1z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
  }));
};
InfoSmallIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var WarningSmallIcon = function WarningSmallIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 9a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1zm0 6.014a1 1 0 0 1 1 1v.01a1 1 0 1 1-2 0v-.01a1 1 0 0 1 1-1z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.276 3.959c.773-1.315 2.675-1.315 3.448 0l8.251 14.027C22.76 19.32 21.798 21 20.252 21H3.748c-1.546 0-2.508-1.68-1.723-3.014L10.276 3.96zM12 4.973 3.748 19h16.504L12 4.973z"
  }));
};
WarningSmallIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "tooltip": "APINavigationDisabled__tooltip__3O_YY",
  "error": "APINavigationDisabled__error__Cuk1V"
}; 
require('./APINavigationDisabled.css');
var APINavigationDisabled = function APINavigationDisabled(_ref) {
  var isEdit = _ref.isEdit,
    error = _ref.error;
  var tooltipContent = /*#__PURE__*/_react.default.createElement("div", {
    className: styles.tooltip
  }, isEdit ? 'API Summary is only editable via API Designer' : 'Error loading API');
  var icon = isEdit ? /*#__PURE__*/_react.default.createElement(InfoSmallIcon, null) : /*#__PURE__*/_react.default.createElement(WarningSmallIcon, null);
  return /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    testId: "api-summary-disabled",
    content: tooltipContent,
    position: "center"
  }, /*#__PURE__*/_react.default.createElement(_SidebarItem.default, {
    className: (0, _classnames.default)(!isEdit && !!error ? styles.error : null),
    isDisabled: true,
    title: "Summary",
    icon: icon
  }, "Summary"));
};
APINavigationDisabled.propTypes = {
  isEdit: _propTypes.default.bool,
  error: _propTypes.default.object
};
var _default = exports.default = APINavigationDisabled;
//# sourceMappingURL=APINavigationDisabled.js.map